import { Box, styled } from '@ltvco/refresh-lib/theme';

export const LoadingContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  textAlign: 'center',
}));
